module.exports = __webpack_public_path__ + "static/img/bannerText1.bae4526.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bannerText1.png
// module id = Pj2H
// module chunks = 1